import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { announceWebSessionReturn } from '../utils/exportWebWindow';

/**
 * Hierheen stuurt de webstap van /export/v2 na afloop door
 * (?session_id=…&status=done|cancelled). De url draagt geen gegevens: deze
 * pagina laat alleen het tabblad met de wizard weten dat hij de stand moet
 * opvragen, en sluit zichzelf als dat mag.
 */
const ExportReturnPage: React.FC = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { sessionId, status } = useMemo(() => {
        const params = new URLSearchParams(location.search);
        return { sessionId: params.get('session_id') ?? '', status: params.get('status') ?? '' };
    }, [location.search]);

    useEffect(() => {
        if (sessionId) announceWebSessionReturn({ sessionId, status });
        // Een venster dat de wizard opende, mag zichzelf sluiten; anders blijft de tekst staan
        const timer = setTimeout(() => {
            try {
                window.close();
            } catch {
                // Niet toegestaan
            }
        }, 600);
        return () => clearTimeout(timer);
    }, [sessionId, status]);

    const key = status === 'done' || status === 'cancelled' ? status : 'other';

    return (
        <div className="min-h-screen bg-background flex flex-col justify-center py-12 px-4 sm:px-6">
            <div className="mx-auto w-full max-w-md rounded-lg bg-white p-6 shadow-sm text-center">
                <p role="status" className="text-sm text-gray-900">{t(`exportWizard.returnPage.${key}`)}</p>
            </div>
        </div>
    );
};

export default ExportReturnPage;
